/**
 * @generated SignedSource<<342f0be71ab8e4675b2f5f70db4fa40a>>
 * @relayHash da333877d997df6d7a9534e1a242778b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0584bda3931c54a314c6a13c20204ef0921e520927cde8d4f33ebe8d9455547

import type { ConcreteRequest, Query } from 'relay-runtime';
export type OnboardingWizardInnerPermissionsQuery$variables = {
  cloudId: string;
  skipDelegatedAdminCheck: boolean;
};
export type OnboardingWizardInnerPermissionsQuery$data = {
  readonly jira: {
    readonly canManageCustomOnboarding?: boolean | null | undefined;
  } | null | undefined;
};
export type OnboardingWizardInnerPermissionsQuery = {
  response: OnboardingWizardInnerPermissionsQuery$data;
  variables: OnboardingWizardInnerPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipDelegatedAdminCheck"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "condition": "skipDelegatedAdminCheck",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "canManageCustomOnboarding",
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "key",
                "value": "ADMINISTER"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OnboardingWizardInnerPermissionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingWizardInnerPermissionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a0584bda3931c54a314c6a13c20204ef0921e520927cde8d4f33ebe8d9455547",
    "metadata": {},
    "name": "OnboardingWizardInnerPermissionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bc3294c503311843720c8103173555a1";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
